export default "__VITE_ASSET__B6h82v9a__"